import { useContext } from "react";
import { AppContext } from "../../contexts/AppContext";

export function ImageCarousel() {
    const app = useContext(AppContext);

    return (
        <div id="carouselAutoplaying" className="carousel slide mb-3 shadow-sm" data-bs-ride="carousel">
            <div className="carousel-inner">
                {app.loading && <div key={`CarouselByOrder_${1}`} className={`carousel-item active`}>
                    <img src={`/app/Carousel/imgOrder?order=${1}`} className="d-block w-100" alt={`Carousel image 0`} />
                </div>}
                {!app.loading && app.baseFeatures.CarouselOrders.map((Corder) => {
                    return <div key={`CarouselByLOrder_${Corder}`} className={`carousel-item ${Corder == 1 ? "active" : ""} `}>
                        <img src={`/app/Carousel/imgOrder?order=${Corder}`} className="d-block w-100" alt={`Carousel image ${Corder}`} />
                    </div>
                })}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselAutoplaying" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselAutoplaying" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    );
}